import { render } from "./TopPageContents.vue?vue&type=template&id=399f8f88"
import script from "./TopPageContents.vue?vue&type=script&lang=js"
export * from "./TopPageContents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__